/**
 * メール送信用の共通サービス
 * @param data 任意の型（フォームデータ）
 * @returns MailBaseRes
 */
export const sendMail = <T>(data: T): Promise<MailBaseRes> => {
  return new Promise<MailBaseRes>(async (resolve, reject) => {
    if (process.env.REACT_APP_MOCK_MODE === 'true') {
      // モック表示モードの場合
      console.debug(data)
      resolve({ status: "success", error: '' })
    } else {
      // 設定値からリクエスト先を取得
      const requestURL = process.env.REACT_APP_MAIL_URL
      try {
        // リクエスト先が取得できない場合はエラーとする
        if (!requestURL) {
          reject('Request Error')
          return
        }

        // 設定値のアドレスに対してリクエストを行う
        const response: Response = await fetch(requestURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Auth-Token": process.env.REACT_APP_X_AUTH_TOKEN || ""
          },
          body: JSON.stringify(data),
        });
        // レスポンス確認
        if (response.ok) {
          // レスポンスからエラーを判定
          const res: MailBaseRes = await response.json()
          if (res.status === 'success') {
            resolve(res)
          } else {
            reject('Internal Server Error')
          }
        } else {
          reject(response.statusText)
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          reject(error.message)
        } else {
          reject('Request Error')
        }
      }
    }
  });
};